import { SidenavMonitorInterface } from "@copec-gid/monitor-mkt.utilitarios-monitor-modulo";
import { environment } from "../../environments/environment";

// Función para ordenar automáticamente las categorías por título
function sortMenuItems(items: SidenavMonitorInterface[]): SidenavMonitorInterface[] {
  return items.sort((a, b) => {
    const titleA = a.titulo || '';
    const titleB = b.titulo || '';
    return titleA.localeCompare(titleB);
  });
}

// Función para normalizar rutas y mantener estado activo después de redirecciones
function normalizeRouteForActiveState(route: string): string {
  // Eliminar barras al inicio y final
  return route.replace(/^\/+|\/+$/g, '');
}

// Función para mejorar la coincidencia de rutas activas
function enhanceMenuItemsForActiveState(items: any[]): any[] {
  return items.map(item => ({
    ...item,
    // Agregar rutas normalizadas para mejor coincidencia
    normalizedRoute: normalizeRouteForActiveState(item.ruta),
    subRutas: item.subRutas ? item.subRutas.map((subItem: any) => ({
      ...subItem,
      normalizedRoute: normalizeRouteForActiveState(subItem.ruta),
      // Agregar ruta completa para subrutas
      fullRoute: `${item.ruta}/${subItem.ruta}`
    })) : []
  }));
}

const mantenedoresUsuario = {
  titulo: "Mantenedores",
  icono: "settings",
  code: "usuarios",
  ruta: "mantenedor-usuarios",
  subRutas: [
    {
      titulo: "Usuarios",
      ruta: "listar-usuarios",
      code: "usuarios",
    },
    {
      titulo: "Crear Usuario",
      ruta: "crear-actualizar",
      code: "crear_usuario",
    },
  ],
};
const abonos = {
  titulo: "Abonos",
  icono: "users",
  code: "aliado_masivo_abono",
  ruta: "carga-masiva",
  subRutas: [
    {
      titulo: "Cargar Abonos",
      ruta: "puntos-abonos",
      code: "aliado_masivo_abono",
    },
    {
      titulo: "Cargar Reversas",
      ruta: "puntos-reversa",
      code: "aliado_masivo_reversa",
    },
    {
      titulo: "hidden",
      ruta: "cupones",
      code: "crear_cupon",
      visible: false,
    },
    {
      titulo: "hidden",
      ruta: "misiones",
      code: "editar_segmentos",
      visible: false,
    },
  ],
};

const banners = {
  titulo: "Banners",
  icono: "sidebar",
  code: "consultar_banners",
  ruta: "banners",
  subRutas: [
    {
      titulo: "Consultar Banners",
      ruta: "listar-banners",
      code: "consultar_banners",
    },
    {
      titulo: "Crear Banner",
      ruta: "crear-opcion",
      code: "crear_banners",
    },
    {
      titulo: "Crear/Actualizar Banner",
      ruta: "crear-actualizar",
      code: "crear_banners",
      visible: false,
    },
  ],
};

const cupones = {
  titulo: "Cupones",
  icono: "percent",
  code: "consultar_cupon",
  ruta: "cupones",
  subRutas: [
    {
      titulo: "Consultar Cupones",
      ruta: "cupon/listar-cupones",
      code: "consultar_cupon",
    },
    {
      titulo: "Crear Cupón",
      ruta: "cupon/crear-opcion",
      code: "crear_cupon",
    },
    {
      titulo: "Crear Cupón",
      ruta: "cupon/crear-cupon",
      code: "crear_cupon",
      visible: false,
    },
    {
      titulo: "Carga Masiva",
      ruta: "carga-masiva",
      code: "crear_cupon",
    },
  ],
};

const promociones = {
  titulo: "Promociones",
  icono: "credit-card",
  code: "promociones",
  ruta: "promociones",
  subRutas: [
    {
      titulo: "Consultar Promociones",
      ruta: "listar-promociones",
      code: "consultar_promociones",
    },
    {
      titulo: "Crear Promoción",
      ruta: "crear-promocion",
      code: "crear_promocion",
    },
    {
      titulo: "Consultar Cupones",
      ruta: "cupones/promocion/listar-cupones",
      code: "consultar_cupon_promocion",
    },
    {
      titulo: "Crear Cupón",
      ruta: "cupones/promocion/crear-opcion",
      code: "crear_cupon_promocion",
    },
    {
      titulo: "Crear Cupón",
      ruta: "cupones/promocion/crear-cupon",
      code: "crear_cupon_promocion",
      visible: false,
    },
    {
      titulo: "prueba",
      ruta: "crear-actualizar",
      code: "crear_promocion",
      visible: false,
    },
    {
      titulo: "Calendario",
      ruta: "ver-calendario",
      code: "consultar_promociones",
      visible: true,
    },
  ],
};

const catalogoTickets = {
  titulo: "Catálogo Tickets",
  icono: "shopping-bag",
  code: "consultar_catalogo_tickets",
  ruta: "catalogo-tickets",
  subRutas: [
    {
      titulo: "Consultar Catálogo",
      ruta: "listar-productos",
      code: "consultar_catalogo_tickets",
    },
    {
      titulo: "Crear Catálogo",
      ruta: "crear-editar-producto",
      code: "crear_catalogo_tickets",
    },
    {
      titulo: "Consultar Lotes",
      ruta: "listar-tickets",
      code: "consultar_lotes",
    },
    {
      titulo: "Cargar Lotes",
      ruta: "crear-ticket",
      code: "crear_lotes",
    }
  ],
};

const catalogoProductos = {
  titulo: "Catálogo Productos",
  icono: "shopping-cart",
  code: "consultar_catalogo",
  ruta: "catalogo",
  subRutas: [
    {
      titulo: "Consultar Catálogo",
      ruta: "listar-productos",
      code: "consultar_catalogo",
    },
    {
      titulo: "Crear Catálogo",
      ruta: "crear-editar-producto",
      code: "crear_catalogo",
    },
    {
      titulo: "Consultar Cupones",
      ruta: "cupones/catalogo/listar-cupones",
      code: "consultar_cupon_catalogo",
    },
    {
      titulo: "Crear Cupón",
      ruta: "cupones/catalogo/crear-opcion",
      code: "crear_cupon_catalogo",
    },
    {
      titulo: "Crear Cupón",
      ruta: "cupones/catalogo/crear-cupon",
      code: "crear_cupon_catalogo",
      visible: false
    }
  ],
};

const misiones = {
  titulo: "Misiones",
  icono: "flag",
  code: "consultar_misiones",
  ruta: "misiones",
  subRutas: [
    {
      titulo: "Consultar Misiones",
      ruta: "listar-misiones",
      code: "consultar_misiones",
    },
    {
      titulo: "Crear Misión",
      ruta: "crear-mision",
      code: "crear_mision",
    },
    {
      titulo: "Crear Misión",
      ruta: "crear-actualizar",
      code: "crear_mision",
      visible: false,
    },
    {
      titulo: "Segmentos",
      ruta: "segmentos",
      code: "consultar_segmentos",
    },
    {
      titulo: "Editar Segmentos",
      ruta: "carga-masiva",
      code: "editar_segmentos",
    },
    {
      titulo: "Crear Cupón",
      ruta: "cupones/misiones/crear-opcion",
      code: "crear_cupon_mision",
    },
    {
      titulo: "Crear Cupón",
      ruta: "cupones/misiones/crear-cupon",
      code: "crear_cupon_mision",
      visible: false,
    },
    {
      titulo: "Consultar Cupones",
      ruta: "cupones/misiones/listar-cupones",
      code: "consultar_cupones_misiones",
    },
    {
      titulo: "Calendario Misiones",
      ruta: "ver-calendario",
      code: "consultar_misiones",
      visible: true,
    },
  ],
};

const codigosPromocionales = {
  titulo: "Códigos",
  icono: "tag",
  code: "consultar_codigo_promocional",
  ruta: "codigos",
  subRutas: [
    {
      titulo: "Consultar Códigos",
      ruta: "listar-codigos",
      code: "consultar_codigo_promocional",
    },
    {
      titulo: "Crear Códigos",
      ruta: "crear-actualizar-codigos",
      code: "crear_codigo_promocional",
    },
    {
      titulo: "Crear Cupón",
      ruta: "cupones/codigos/crear-opcion",
      code: "crear_cupon_cod_promo",
    },
    {
      titulo: "Crear Cupón",
      ruta: "cupones/codigos/crear-cupon",
      code: "crear_cupon_cod_promo",
      visible: false,
    },
    {
      titulo: "Consultar Cupones",
      ruta: "cupones/codigos/listar-cupones",
      code: "consultar_cupones_cod_promo",
    },
    {
      titulo: "prueba",
      ruta: "crear-actualizar-codigos",
      code: "crear_codigo_promocional",
      visible: false,
    },
    {
      titulo: "Consultar Códigos Unicos",
      ruta: "listar-codigos-unicos",
      code: "consultar_codigo_unicos",
    },
    {
      titulo: "Crear Códigos Unicos",
      ruta: "crear-actualizar-codigos-codigos-unicos",
      code: "crear_codigo_unicos",
    },

    {
      titulo: "prueba",
      ruta: "crear-actualizar-codigos-codigos-unicos",
      code: "crear_codigo_unicos",
      visible: false,
    },
  ],
};

const aliados = {
  titulo: "Aliados",
  icono: "activity",
  code: "consultar_aliados",
  ruta: "aliados",
  subRutas: [
    {
      titulo: "Consultar Aliados",
      ruta: "listar-aliados",
      code: "consultar_aliados",
    },
    {
      titulo: "Crear Aliado",
      ruta: "crear-aliado",
      code: "crear_aliados",
    },
    {
      titulo: "prueba",
      ruta: "crear-actualizar-aliados",
      code: "crear_aliados",
      visible: false,
    },
    {
      titulo: "Crear Cupón",
      ruta: "cupones/aliados/crear-opcion",
      code: "crear_cupon_aliados",
    },
    {
      titulo: "Consultar Cupones",
      ruta: "cupones/aliados/listar-cupones",
      code: "consultar_cupones_aliados",
    },
    {
      titulo: "Consultar Plantillas",
      ruta: "",
      code: "",
    },
    {
      titulo: "Crear Plantilla Cupón",
      ruta: "crear-plantilla-cupones",
      code: "crear_aliados",
    },
  ],
};

const empresas = {
  titulo: "Empresas",
  icono: "briefcase",
  code: "restriccion_empresas",
  ruta: "empresas",
  subRutas: [], // Ruta directa
};

let config: SidenavMonitorInterface[] = [];

switch (environment.urlEnv) {
  case "QA":
    config = enhanceMenuItemsForActiveState([
      mantenedoresUsuario as SidenavMonitorInterface,
      ...sortMenuItems([
        abonos as SidenavMonitorInterface,
        banners as SidenavMonitorInterface,
        cupones as SidenavMonitorInterface,
        promociones as SidenavMonitorInterface,
        catalogoTickets as SidenavMonitorInterface,
        catalogoProductos as SidenavMonitorInterface,
        misiones as SidenavMonitorInterface,
        codigosPromocionales as SidenavMonitorInterface,
        empresas as SidenavMonitorInterface,
        aliados as SidenavMonitorInterface,
      ])
    ]);
    break;
  case "PR":
    config = enhanceMenuItemsForActiveState([
      mantenedoresUsuario as SidenavMonitorInterface,
      ...sortMenuItems([
        abonos as SidenavMonitorInterface,
        banners as SidenavMonitorInterface,
        cupones as SidenavMonitorInterface,
        promociones as SidenavMonitorInterface,
        catalogoProductos as SidenavMonitorInterface,
        misiones as SidenavMonitorInterface,
        empresas as SidenavMonitorInterface,
        codigosPromocionales as SidenavMonitorInterface,
        aliados as SidenavMonitorInterface,
        catalogoTickets as SidenavMonitorInterface,
    ])]);
    break;
  default:
    config = enhanceMenuItemsForActiveState([
      mantenedoresUsuario as SidenavMonitorInterface,
      ...sortMenuItems([
        abonos as SidenavMonitorInterface,
        banners as SidenavMonitorInterface,
        cupones as SidenavMonitorInterface,
        promociones as SidenavMonitorInterface,
        catalogoTickets as SidenavMonitorInterface,
        catalogoProductos as SidenavMonitorInterface,
        misiones as SidenavMonitorInterface,
        codigosPromocionales as SidenavMonitorInterface,
        empresas as SidenavMonitorInterface,
        aliados as SidenavMonitorInterface,
    ])]);
    break;
}

export const SIDENAV_CONFIG: SidenavMonitorInterface[] = config;
